import { useState } from "react";
import { breakingTicker } from "@/mocks/homeData";

const navLinks = [
  { label: "今日封面", href: "#cover" },
  { label: "热度榜", href: "#hot" },
  { label: "专题合集", href: "#topics" },
  { label: "深度长文", href: "#feed" },
  { label: "时间线", href: "#timeline" },
  { label: "观点交锋", href: "#voices" },
];

export default function Masthead() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40">
      {/* utility strip */}
      <div className="bg-primary-900 text-foreground-100">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-1.5 text-[11px] md:px-6">
          <p className="flex items-center gap-2">
            <span className="hidden h-1.5 w-1.5 rounded-full bg-accent-500 sm:inline-block" />
            <span className="tracking-wide">编辑部 · 深挖与时间线追踪 · 2026.09.09</span>
          </p>
          <p className="flex items-center gap-3 text-foreground-300">
            <span className="hidden items-center gap-1 sm:flex">
              <i className="ri-archive-line text-xs" />
              <span>档案库持续扩编中</span>
            </span>
            <span className="inline-flex items-center gap-1 text-accent-300">
              <i className="ri-radar-line text-xs" />
              今日追踪 27 条
            </span>
          </p>
        </div>
      </div>

      {/* main masthead */}
      <div className="border-b border-primary-800 bg-primary-950 text-background-50">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-3.5 md:px-6">
          {/* brand */}
          <a href="#cover" className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-600 text-lg font-black">
              <i className="ri-eye-line" />
            </div>
            <div className="leading-none">
              <p className="font-heading text-2xl font-black tracking-tight md:text-[1.7rem]">
                最全<span className="text-accent-400">黑料</span>
              </p>
              <p className="mt-1 text-[10px] font-medium tracking-[0.22em] text-foreground-100/70">
                内幕 · 真相 · 始末时间线
              </p>
            </div>
          </a>

          {/* desktop nav */}
          <nav className="hidden items-center gap-7 lg:flex">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="cursor-pointer text-sm text-foreground-100/80 transition-colors hover:text-background-50"
              >
                {l.label}
              </a>
            ))}
          </nav>

          {/* actions */}
          <div className="flex items-center gap-2">
            <button
              type="button"
              aria-label="搜索"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-primary-700 text-foreground-100 transition-colors hover:bg-primary-800"
            >
              <i className="ri-search-line text-base" />
            </button>
            <button
              type="button"
              className="hidden h-9 cursor-pointer items-center gap-1.5 rounded-full border border-primary-700 px-3 text-sm text-foreground-100 transition-colors hover:bg-primary-800 sm:flex"
            >
              <i className="ri-notification-3-line text-base" />
              <span className="whitespace-nowrap">追更提醒</span>
            </button>
            <button
              type="button"
              className="hidden h-9 cursor-pointer items-center rounded-full bg-accent-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:flex"
            >
              <span className="whitespace-nowrap">我要爆料</span>
            </button>
            {/* hamburger */}
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-primary-700 text-foreground-100 lg:hidden"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>

        {/* mobile nav panel */}
        {open && (
          <nav className="border-t border-primary-800 px-4 py-2 lg:hidden">
            <div className="flex flex-col">
              {navLinks.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="cursor-pointer border-b border-primary-800/60 py-3 text-sm text-foreground-100/85 last:border-0"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#footer"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex h-9 items-center justify-center rounded-full bg-accent-500 text-sm font-semibold text-background-50"
              >
                我要爆料
              </a>
            </div>
          </nav>
        )}
      </div>

      {/* breaking / update ticker */}
      <div className="flex items-stretch border-b border-accent-700 bg-accent-600">
        <div className="flex shrink-0 items-center gap-2 bg-accent-700 px-3 py-2 md:px-5">
          <span className="live-dot h-2 w-2 rounded-full bg-background-50" />
          <span className="whitespace-nowrap font-label text-xs font-bold tracking-widest text-background-50">
            最新更新
          </span>
        </div>
        <div className="relative flex flex-1 items-center overflow-hidden">
          <div className="ticker-track gap-10 px-4 py-2">
            {[...breakingTicker, ...breakingTicker].map((it, idx) => (
              <span
                key={`${it.id}-${idx}`}
                className="inline-flex items-center gap-2 whitespace-nowrap text-xs text-background-50/95 md:text-[13px]"
              >
                <span className="inline-flex h-4 min-w-4 items-center justify-center rounded-sm bg-accent-800 px-1 text-[10px] font-bold">
                  {it.mark}
                </span>
                <span className="opacity-70">{it.time}</span>
                <span>{it.text}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}